var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488.48 488.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.42,350.1h-43.5v-81.14c0-1.7-1.67-8.62-2.34-10.64-6.55-19.69-35.86-18.23-43.46-.02-.9,2.16-3.25,10.6-3.25,12.51v79.28h-43.5v-140.95h41.65v19.47c8.41-11.66,19.85-20.87,34.72-22.24,39.88-3.67,57.26,15.94,59.67,54.24,1.84,29.16-1.35,60.13,0,89.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 142.12,
    y: 209.16,
    width: 44.42,
    height: 140.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.61,138.91c40.93-6.96,40.93,56.59,0,49.63-25.51-4.34-25.51-45.3,0-49.63Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.63,46.84c47.46,4.78,85.23,42.32,88.94,90.09v215.39c-3.62,46.86-41.65,85.38-88.49,89.32h-209.69c-48.53-3.6-86.97-44.21-89.3-92.58,2.88-68.75-3.72-140.47,0-208.87,2.64-48.65,40.6-89.63,89.76-93.35h208.8ZM153.71,78.07c-39.43,4.66-70.02,37.16-72.46,76.8-3.63,59,2.79,121.71.05,181.1,4.01,41.08,36.57,72.79,77.89,75.45,55.72,3.59,115.16-2.66,171.26,0,40.47-2.31,73.61-33.47,77.89-73.82v-186.75c-4.32-38.15-34.88-68.78-73.09-72.91l-181.54.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.52a8301a5b3365f7345bec139ef74ca5.svg";
export { ForwardRef as ReactComponent };